/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/6/10
 * Time: 17:30
 * Desc: 虚拟店长管理-虚拟店长信息
 */

import { Component, Vue } from 'vue-property-decorator';
import NoAuth from '@/views/components/noAuth/noAuth.vue';

// 子组件
// import DistributeHistory from "@/views/components/distributeHistory/distributeHistory.vue"; // 分销历史
// import WithdrawHistory from "@/views/components/withdrawHistory/withdrawHistory.vue"; // 提现历史
import DistributeBoardHistory from '@/views/components/distributeBoardHistory/distributeBoardHistory.vue'; // 分销历史
import WithdrawBoardHistory from '@/views/components/withdrawBoardHistory/withdrawBoardHistory.vue'; // 提现历史

@Component({
  components: {
    // DistributeHistory,
    // WithdrawHistory,
    DistributeBoardHistory,
    WithdrawBoardHistory,
    NoAuth,
  },
})
export default class VirtualManageInfo extends Vue {
  /* 数据 */

  /**
   * 当前页面的索引
   * @type {string}
   */
  public curPage = '1';

  public vGuiderSource = 0;

  /**
   * 内容是否显示
   * @type {boolean}
   */
  public isContentBodyShow = false;
  public isContentBodyShow2 = false;

  /* 方法 */

  /**
   * 切换页面
   */
  public onPageSwitch(key): void {
    this.curPage = key;
    localStorage.setItem('curpage', key);
    localStorage.setItem('vGuiderSource', Number.parseInt(this.$route.params.vGuiderSource).toString());
  }

  /* 周期 */
  goHome() {
    this.$router.push({ path: '/distributeBoard', query: { index: '2' } });
  }

  /**
   * 当组建创建时
   */
  public created() {
    // 权限检测
    this.isContentBodyShow = this.$store.state.authMenuCodeList.includes('VSHOP-FUNCTION-DISTRIBUTE-VIRGUIDER');
    this.isContentBodyShow2 = this.$store.state.authMenuCodeList.includes('VSHOP-FUNCTION-REPORT-V-GUIDER');
    if (this.isContentBodyShow || this.isContentBodyShow2) {
      localStorage.setItem('vGuiderSource', Number.parseInt(this.$route.params.vGuiderSource).toString());

      // 来自提现管理页面
      if (localStorage.getItem('remit') === '1') {
        this.curPage = '2'; // 直接跳到配置页
        localStorage.setItem('curpage', '2');
        localStorage.removeItem('remit');
      } else {
        // 获取当前页索引
        this.curPage = localStorage.getItem('curpage') ? localStorage.getItem('curpage') : '1';
      }
    }
  }
}
